<template>
  <div class="Crmactivemanage-ticketActivity">
    <PageNav>
      <div id="page-ticketActivity">
        <div class="head-tab--nav">
          <div class="head-nav h-3 clearFloat">
            <span class="c-normal">{{ $t("Crmactivemanage.am") }}</span>
            <div class="pull-right">
              <el-button type="primary" @click="handDaochu">{{
                $t("Common.btn_export")
              }}</el-button>
              <!-- <el-button type="warning">发布活动</el-button> -->
            </div>
          </div>
        </div>
        <div class="ticketActivity-container">
          <div class="content">
            <div class="flex-wrap">
              <div class="flex-al mb20 mr10">
                <span class="mr10 fs14 color-666">{{
                  $t("Crmactivemanage.ac")
                }}</span>
                <div class="time-box flex-al">
                  <el-date-picker
                    type="date"
                    :placeholder="$t('Common.startTime')"
                    value-format="yyyy-MM-dd"
                    v-model="selectForm.activity_starttime"
                    @change="handleSelect()"
                    style="width: 130px"
                  ></el-date-picker>
                  <span class="ml10 mr10">{{ $t("Crmactivemanage.ae") }}</span>
                  <el-date-picker
                    type="date"
                    :placeholder="$t('Common.endTime')"
                    value-format="yyyy-MM-dd"
                    v-model="selectForm.activity_endtime"
                    @change="handleSelect()"
                    style="width: 130px"
                  ></el-date-picker>
                </div>
              </div>
              <div class="flex-al mb20 mr10">
                <span class="mr10 fs14 color-666">{{
                  $t("Crmactivemanage.ag")
                }}</span>
                <div class="select-box" style="width: 170px">
                  <el-select
                    v-model="selectForm.found_marketer_id"
                    clearable
                    filterable
                    :placeholder="$t('Crmactivemanage.ah')"
                    @change="handleSelect()"
                  >
                    <el-option
                      v-for="item in founder"
                      :key="item.marketer_id"
                      :label="`${item.marketer_name} ${
                        item.staffer_enname
                          ? '(' + item.staffer_enname + ')'
                          : ''
                      }`"
                      :value="item.marketer_id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex-al Inquire-box mb20">
                <div class="ipt-box">
                  <el-input
                    v-model="selectForm.keyword"
                    class="input-cont"
                    clearable
                    :placeholder="$t('Crmactivemanage.cn')"
                    @change="handleSelectKeyword()"
                  ></el-input>
                </div>
                <el-button
                  type="primary"
                  @click="handleSelectKeyword()"
                  class="btn-inquire fs14"
                  >{{ $t("Crmactivemanage.as") }}</el-button
                >
              </div>
            </div>
            <div class="tableDiv" ref="auto_height_table">
              <imgTableCont
                :tableData="tableList"
                @handSetting="handSetting"
                @handleCodeChange="handleCodeChange"
              >
                <!-- 按钮操作组********start -->
                <el-table-column
                  ref="fixedColumn"
                  :label="$t('Crmactivemanage.bg')"
                  align="center"
                  width="150px"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click.native.prevent="handSee(scope.row)"
                      >{{ $t("Crmactivemanage.bw") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click.native.prevent="handAdmList(scope.row)"
                      >{{ $t("Crmactivemanage.co") }}</el-button
                    >
                  </template>
                </el-table-column>
                <!-- 按钮操作组********end -->
              </imgTableCont>
              <!-- 分页 -->
              <el-pagination
                style="margin: 10px"
                :current-page.sync="paging.curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size.sync="paging.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.pageTotal"
                @current-change="curPageChange"
                @size-change="pageSizeChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </PageNav>

    <!-- 二维码 -->
    <!-- 二维码 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="tan-code clearFloat"
      width="500px"
      :before-close="handleCloseCode"
    >
      <div
        class="pull-right h1 btn-close font-333"
        style="cursor: pointer"
        @click="handleCloseCode"
      >
        <i class="el-icon-close"></i>
      </div>
      <div class="code">
        <div class="code-img">
          <div class="left">
            <p v-if="languageType == 'zh'">{{ $t("Crmactivemanage.at") }}</p>
            <div
              class="one-img"
              :class="{ 'one-tw-img': languageType != 'zh' }"
            >
              <img :src="onCodeInfo.oneCodeImg" alt />
            </div>
          </div>
          <div v-if="languageType == 'zh'" class="right">
            <p>{{ $t("Crmactivemanage.au") }}</p>
            <iframe
              frameborder="0"
              :src="onCodeInfo.oneCodeWxImg"
              width="220"
              height="220"
            ></iframe>
            <!-- <img :src="onCodeInfo.oneCodeWxImg" alt /> -->
          </div>
        </div>
        <p class="h1">{{ $t("Crmactivemanage.av") }}</p>
      </div>
      <p style="text-align: center">
        {{ $t("Crmactivemanage.aw") }}{{ onCodeInfo.oneCodeUrl }}
      </p>
    </el-dialog>

    <!-- 招生券管理 -->
    <SliderBox
      :showSliderBox="showTicktActivities"
      @hideSliderBox="hideTicktActivities"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain slider-activitiesManage silder-contain-seeing">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Crmactivemanage.bw") }}
          </p>
          <div
            class="pull-right h1 btn-close font-gray"
            @click="hideTicktActivities"
          >
            <i class="el-icon-close"></i>
          </div>
          <div class="pull-right">
            <el-button type="warning" @click="handAdd()">{{
              $t("Crmactivemanage.bss")
            }}</el-button>
            <el-button type="primary" @click="daochu">{{
              $t("Crmactivemanage.by")
            }}</el-button>
          </div>
        </div>
        <div class="slider-cont">
          <div class="flex-wrap slider-select">
            <div class="flex-al mb20 mr10">
              <span class="fs14 color-666 mr10">{{
                $t("Crmactivemanage.bz")
              }}</span>
              <div class="select-box">
                <el-select
                  v-model="selectForm1.ticket_status"
                  clearable
                  filterable
                  :placeholder="$t('Crmactivemanage.ca')"
                  @change="handleSelect1()"
                >
                  <el-option
                    :label="$t('Crmactivemanage.ak')"
                    value
                  ></el-option>
                  <el-option
                    :label="$t('Crmactivemanage.cb')"
                    value="0"
                  ></el-option>
                  <el-option
                    :label="$t('Crmactivemanage.cc')"
                    value="1"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-al Inquire-box mb20">
              <div class="ipt-box">
                <el-input
                  v-model="selectForm1.keyword"
                  class="input-cont"
                  clearable
                  :placeholder="$t('Crmactivemanage.cd')"
                  @change="handleSelect1()"
                ></el-input>
              </div>
              <el-button
                type="primary"
                class="btn-inquire fs14"
                @click="handleSelect1()"
                >{{ $t("Crmactivemanage.as") }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="tableDiv mr20 ml20" ref="auto_ticket_height_table">
          <noBorderTableCont
            :tableData="tableListTicket"
            @handSetting="handSetting"
          ></noBorderTableCont>
        </div>
      </div>
    </SliderBox>

    <!-- 生成招生券 -->
    <el-dialog
      :title="$t('Crmactivemanage.ce')"
      :visible.sync="ticketItem"
      class="tan-binding"
      width="500px"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="95px"
          :model="ticketForm"
          ref="ticketForm"
          :rules="ticketRules"
          style="padding: 0px"
        >
          <el-form-item :label="$t('Crmactivemanage.bt')" prop="ticket_name">
            <el-input
              v-model="ticketForm.ticket_name"
              style="width: 300px"
              :placeholder="$t('Crmactivemanage.cf')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Crmactivemanage.bss')" prop="ticket_note">
            <el-input
              type="textarea"
              clearable
              v-model="ticketForm.ticket_note"
              :placeholder="$t('Crmactivemanage.cg')"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('Crmactivemanage.ch')"
            style="width: 395px"
            required
          >
            <el-col :span="11">
              <el-form-item prop="ticket_starttime">
                <el-date-picker
                  type="date"
                  :placeholder="$t('Crmactivemanage.ad')"
                  value-format="yyyy-MM-dd"
                  v-model="ticketForm.ticket_starttime"
                  :picker-options="pickerOptionsStartCreate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col class="line" :span="2">-</el-col> -->
            <el-col :span="2" style="padding-left: 3px">{{
              $t("Crmactivemanage.ae")
            }}</el-col>
            <el-col :span="11">
              <el-form-item prop="ticket_endtime">
                <el-date-picker
                  type="date"
                  :placeholder="$t('Crmactivemanage.af')"
                  :picker-options="pickerOptionsEndCreate"
                  value-format="yyyy-MM-dd"
                  v-model="ticketForm.ticket_endtime"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('Crmactivemanage.ci')" prop="num">
            <el-input
              v-model="ticketForm.num"
              style="width: 300px"
              :placeholder="$t('Crmactivemanage.cj')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onTicketSubmit()">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
        <el-button @click="ticketItem = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import imgTableCont from "../../components/tables/imgTableCont.vue";
import noBorderTableCont from "../../components/tables/noBorderTableCont.vue";
import SliderBox from "../../components/SliderBox";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";

export default {
  name: "Crmactivemanage-ticketActivity",
  data() {
    return {
      //二维码
      dialogVisible: false,
      onCodeInfo: {
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      creatimageUrl: "",
      imageUrl: "",
      dialogimgVisible: false,
      input: "",
      select: "",
      sliderWidth: "800px",
      activeName: "first",
      activeName1: "first",
      activityId: "", //暂存查看的活动id
      infoForm: {
        a_content: "",
        editorOption: {},
      },
      //招生券描述
      ticketForm: {
        ticket_name: "", //券名称
        ticket_note: "", //备注
        ticket_starttime: "", //有效开始时间
        ticket_endtime: "", //有效结束时间
        num: "", //个数
      },
      //招生券描述*****校验规则
      ticketRules: {
        ticket_name: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cf"),
            trigger: "blur",
          },
        ],
        ticket_note: [{ required: false, trigger: "blur" }],
        ticket_starttime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.ck"),
            trigger: "change",
          },
        ],
        ticket_endtime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cl"),
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: this.$t("Crmactivemanage.cj"),
            trigger: "blur",
          },
        ],
      },
      //时间选择排序
      pickerOptionsStartCreate: {
        disabledDate: (time) => {
          if (this.ticketForm.ticket_endtime) {
            return (
              time.getTime() <
              new Date(this.ticketForm.ticket_endtime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEndCreate: {
        disabledDate: (time) => {
          if (this.ticketForm.ticket_starttime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <=
                new Date(this.ticketForm.ticket_starttime).getTime()
            );
          } else {
            return (
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() >=
                new Date(this.ticketForm.ticket_starttime).getTime()
            );
          }
        },
      },
      //筛选条件
      selectForm: {
        activity_starttime: "",
        activity_endtime: "",
        found_marketer_id: "",
        activity_pattern: "1", //活动类型
        channel_id: "", //渠道明细
        frommedia_name: "", //渠道类型
        keyword: "",
      },
      //筛选条件--招生券管理
      selectForm1: {
        ticket_status: "",
        keyword: "",
      },
      //创建人
      founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      //招生券管理
      sliderSeeWidth: "700px",
      showSliderBoxSee: false,
      ticketItem: false, //生成招生券
      showTicktActivities: false, //查看招生券管理
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 0,
        },
      },

      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 10,
      },
      // 招生券管理表格数据
      tableListTicket: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: "300px", //表格高度
        },
      },
      // 添加或者编辑区域表单
      FormData: {
        district_cnname: "",
        district_branch: "",
        district_content: "",
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    imgTableCont,
    noBorderTableCont,
  },
  updated() {},
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    this.getsellActivityData();
    this.getActivityFounderData(); // 获取目标创建人管理
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    //招生券活动
    getsellActivityData() {
      CrmActiveManage.getsellActivity({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_pattern: 1,
        p: this.paging.curPage,
        num: this.paging.pageSize,
        is_count: "1", //是否需要总数，可以不传
        //筛选条件
        keyword: this.selectForm.keyword,
        activity_starttime: this.selectForm.activity_starttime,
        activity_endtime: this.selectForm.activity_endtime,
        found_marketer_id: this.selectForm.found_marketer_id,
        frommedia_name: this.selectForm.frommedia_name,
        channel_id: this.selectForm.channel_id,
      }).then((res) => {
        this.tableList.list = res.data.data.list;
        this.paging.pageTotal = res.data.data.allnum;
        this.tableList.columns = res.data.data.field;
        this.tableList.options.loading = false;
        if (res.data.code !== 200) {
          this.tableList.options.errortip = res.data.msg;
        }
      });
    },
    //招生券管理
    getenrollTicketData() {
      CrmActiveManage.enrollTicketList({
        activity_id: this.activity_id,
        school_id: this.school_id,
        import: this.import,
        //筛选条件
        keyword: this.selectForm1.keyword,
        ticket_status: this.selectForm1.ticket_status, //使用状态 0未使用1已使用
      }).then((res) => {
        this.tableListTicket.list = res.data.data.list;
        this.tableListTicket.columns = res.data.data.field;
        this.tableListTicket.options.loading = false;
        if (res.data.code !== 200) {
          this.tableListTicket.options.errortip = res.data.msg;
        }
      });
    },
    // 生成招生券提交
    onTicketSubmit() {
      this.$refs["ticketForm"].validate((valid) => {
        if (valid) {
          CrmActiveManage.createEnrollTicketAction({
            company_id: this.company_id,
            school_id: this.school_id,
            activity_id: this.activity_id,
            ticket_name: this.ticketForm.ticket_name,
            ticket_note: this.ticketForm.ticket_note,
            ticket_starttime: this.ticketForm.ticket_starttime,
            ticket_endtime: this.ticketForm.ticket_endtime,
            num: this.ticketForm.num,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.ticketItem = false;
              this.getenrollTicketData();
              this.getsellActivityData();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 选择查询
    handleSelect() {
      this.paging.curPage = 1;
      this.getsellActivityData();
    },
    // 选择单个活动招生券
    handleSelect1() {
      this.getenrollTicketData();
    },

    // 获取目标创建人管理
    getActivityFounderData() {
      CrmActiveManage.getActivityFounder({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
      }).then((res) => {
        // 
        this.founder = res.data.data.data;
      });
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.paging.curPage = 1;
      this.getsellActivityData();
    },

    // 点击生成招生券
    handAdd() {
      this.ticketItem = !this.ticketItem;
      if (this.$refs["ticketForm"]) {
        this.$refs["ticketForm"].resetFields();
      }
    },
    // 招生券管理
    handSee(v) {
      (() => {})(v);
      // this.showTicktActivities = true;
      this.activity_id = v.activity_id;
      this.$router.push({
        path: `/Crmactivemanage/crmTicketMange?id=${this.activity_id}`,
      });
      // this.$nextTick(() => {
      //   if (this.$refs["auto_ticket_height_table"]) {
      //     this.tableListTicket.options.tableHeight = this.$Common.getTableHeight(
      //       this.$refs.auto_ticket_height_table.getBoundingClientRect().top + 62
      //     );
      //   }
      // });
      // this.getenrollTicketData();
    },
    // 招生名单
    handAdmList(v) {
      (() => {})(v);
      this.$router.push({
        path: `/Crmactivemanage/crmAdmissionList?id=${v.activity_id}`,
      });
    },
    hideTicktActivities() {
      this.showTicktActivities = false;
    },
    // 编辑列编辑提交
    handSetting(v) {
      (() => {})(v);
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.getsellActivityData();
    },
    // pageSize改变
    pageSizeChange() {
      this.paging.curPage = 1;
      this.getsellActivityData();
    },
    handleCloseCode(done) {
      this.dialogVisible = false;
    },
    handleClose(done) {
      done();
    },
    // 导出操作
    daochu() {
      let url = CrmActiveManage.enrollTicketList1();
      var is_import = 1;
      if (this.tableListTicket.list.length > 0) {
        window.open(
          this.$buildExportUrl(`${url}?marketer_id=${this.marketer_id}&token=${this.token}&activity_id=${this.activity_id}&school_id=${this.school_id}&company_id=${this.company_id}&import=${is_import}&keyword=${this.selectForm1.keyword}&ticket_status=${this.selectForm1.ticket_status}`),
          "_blank"
        );
      } else {
        this.$message.error(this.$t("Crmactivemanage.cm"));
      }
    },
    //点击查看二维码
    handleCodeChange(k, v, col) {
      (() => {})(k, v, col);
      if (col.isschool == "1") {
        this.onCodeInfo.oneCodeImg = v.qrcode; //学校二维码
        // axios
        //   .get(`${v.QRcodeUrl}`, {
        //     params: {}
        //   })
        //   .then(res => {
        //     (() => {})(res);
        //     if (res.data.code === 200) {
        //     }
        //   });
        this.onCodeInfo.oneCodeWxImg = v.QRcodeUrl; //学校二维码
        this.onCodeInfo.oneCodeUrl = v.qrcodeurl;
      } else {
        this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
        this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
        this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
      }
      this.dialogVisible = true;
    },
    //管理列表导出
    handDaochu() {
      let params_str = "",
        is_export = 1;
      for (name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = CrmActiveManage.getsellActivity1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&activity_pattern=1&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableList.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");
.Crmactivemanage-ticketActivity {
  height: 100vh;
  font-size: 14px;
  .tan-code {
    .code {
      text-align: center;
      // width: 70%;
      // margin: 0 auto;
      img {
        display: block;
        width: 100%;
        margin: 0 auto;
      }
      p {
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog {
      margin-top: 24vh;
    }
  }
  // .code {
  //   width: 200px;
  //   text-align: center;
  //   margin: 20px auto;
  //   img {
  //     width: 100%;
  //   }
  // }
  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      img {
        width: 165px !important;
        height: 165px;
      }
    }
    .left {
      margin-right: 10px;
      .one-img {
        width: 220px;
        height: 220px;
        padding-top: 13px;
      }
      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }
    .right {
      margin-left: 10px;
    }
    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
